export default [
	{
		"id": "yosemite",
		"name": "Yosemite area",
		"place": "yosemite",
		"source": {
			"repository": "n30g30/america-backend",
			"file": "include/routes/nQSS5RYwfnOmOJ3lTufSO.json",
			"sha256": "5ed581c4413bef2a663afcb40dedb8657763c135904e1356ebe00e481a553729",
			"startIndex": 33106,
			"endIndex": 33706
		},
		"start": {
			"latitude": 37.815756,
			"longitude": -119.507506
		},
		"end": {
			"latitude": 37.848916,
			"longitude": -119.673269
		},
		"distanceKm": 23.3,
		"durationMinutes": 20,
		"segments": 600
	},
	{
		"id": "monument-valley",
		"name": "Monument Valley area",
		"place": "monument-valley",
		"source": {
			"repository": "n30g30/america-backend",
			"file": "include/routes/BsA5xusyWRds8_mFhV9EJ.json",
			"sha256": "ea37d52df6aadb1f0fd7caf21c3f141eeabbae856efddb751db7d4b5fddb3633",
			"startIndex": 22939,
			"endIndex": 23539
		},
		"start": {
			"latitude": 37.198771,
			"longitude": -109.878999
		},
		"end": {
			"latitude": 36.706828,
			"longitude": -110.253196
		},
		"distanceKm": 79.4,
		"durationMinutes": 59,
		"segments": 600
	},
	{
		"id": "new-orleans",
		"name": "New Orleans area",
		"place": "new-orleans",
		"source": {
			"repository": "n30g30/america-backend",
			"file": "include/routes/OfinpzdQFSaDBJmeB9GHl.json",
			"sha256": "98f412af977470c24d035f75a93a2ce83a6c6a068402013fbdae977a41015e21",
			"startIndex": 26995,
			"endIndex": 27527
		},
		"start": {
			"latitude": 29.919448,
			"longitude": -90.190182
		},
		"end": {
			"latitude": 29.928746,
			"longitude": -89.991444
		},
		"distanceKm": 24.3,
		"durationMinutes": 35,
		"segments": 532
	}
];
